import { styled, css, CollectionIcon } from 'canoe';
import React from 'react';

import { useEditor } from 'craft/hooks';

import { DisplayName } from './DisplayName';
import { DragNode } from './DragNode';

const Container = styled.div<{ isMappedOverSource?: boolean }>`
  ${({ theme, isMappedOverSource }) => css`
    background: ${isMappedOverSource ? theme.colors.MangoOrangeD10 : theme.colors.BrandPurple};
    border: 1px solid
      ${isMappedOverSource ? theme.colors.MangoOrangeD10 : theme.colors.BrandPurpleD10};
    color: ${theme.colors.White};

    font-size: 14px;
    font-weight: 600;
    display: flex;
    padding: 2px ${theme.spaces.xxs};

    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    align-items: center;
    right: 0;

    font-family: sofia-pro, sans-serif;
    text-overflow: ellipsis;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    height: 24px;
  `}
`;

const StyledCollectionIcon = styled(CollectionIcon)`
  height: 14px;
  width: 14px;
`;

interface NodeLabelMenuProps {
  nodeId: string;
  isMappedOverSource: boolean;
  onRenderMenu: () => void;
}
export const NodeLabelMenu = React.forwardRef<HTMLDivElement, NodeLabelMenuProps>(
  ({ nodeId, isMappedOverSource, onRenderMenu }: NodeLabelMenuProps, ref) => {
    const { query } = useEditor();
    const { mode } = query.getOptions();
    return (
      <Container ref={ref} isMappedOverSource={isMappedOverSource}>
        {query.node(nodeId).isDraggable() && mode !== 'readonly' ? (
          <DragNode nodeId={nodeId} />
        ) : null}
        {isMappedOverSource && <StyledCollectionIcon color="White" mr="xxs" />}
        <DisplayName nodeId={nodeId} onRenderMenu={onRenderMenu} />
      </Container>
    );
  },
);
